import { OverlayModule } from '@angular/cdk/overlay';
import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EventType, Router } from '@angular/router';
import { ShopSetupChecklistComponent } from '../../modules/shop-setup-checklist/shop-setup-checklist.component';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatIconModule, OverlayModule, ShopSetupChecklistComponent],
  selector: 'app-checklist-widget',
  template: `
    <button
      mat-stroked-button
      color="primary"
      class="checklist-trigger"
      (click)="isOpen = !isOpen"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      <mat-icon>checklist</mat-icon>
      Checklist
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayOffsetY]="8"
      (overlayOutsideClick)="isOpen = !isOpen"
    >
      <app-shop-setup-checklist />
    </ng-template>
  `,
  styles: [
    `
      .checklist-trigger {
        background-color: #eaf2fb;
        border: 1px solid #bfd6f2;
        border-radius: 12px;
        color: #1d4f91;
      }
    `,
  ],
})
export class ChecklistWidgetComponent {
  isOpen = false;
  readonly overlayPositions = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];

  private readonly routerEvents = toSignal(inject(Router).events);

  private readonly effect = effect(() => {
    if (this.routerEvents().type === EventType.NavigationStart) {
      this.isOpen = false;
    }
  });

  ngOnDestroy() {
    this.effect.destroy();
  }
}
